import React, { Component } from 'react'
import { connect } from 'react-redux'

import Modal from '../Shared/Modal'
import ModalHeader from '../Shared/ModalHeader'
import ModalBody from '../Shared/ModalBody'
import ModalFooter from '../Shared/ModalFooter'

import {
	showHideModalDelete
} from '../../actions/garantias'

class ModalDelete extends Component {
	handleCloseModal = (e) => {
		const modal = document.getElementById('modalDelete')
		modal.classList.remove('fadeIn')
		modal.classList.add('fadeOut')

		const modalDialog = document.querySelector(`#modalDelete .modal-dialog`)
		modalDialog.classList.remove('zoomIn')
		modalDialog.classList.add('zoomOut')

		setTimeout(() => this.props.showHideModalDelete(false), 300)
	}

	render() {
		const { modalDelete } = this.props
		if (!modalDelete.get('show')) {
			return null
		}
		return(
			<Modal id="modalDelete" show={ true } ZIndex={ 2000 } >
				<ModalHeader title="Confirmación" onClose={ (e) => this.handleCloseModal(e) } />
				<ModalBody>
					<div style={{ width: '400px' }}>
						<div className="row">
							<div className="col-md-12" style={{ color: '#000', fontWeight: '300' }}>
								{
									modalDelete.get('message') || 'Esta seguro que desea eliminar este registro?'
								}
							</div>
						</div>
					</div>
				</ModalBody>
				<ModalFooter>
					<button className="btn btn-default" type="button" onClick={ (e) => this.handleCloseModal(e) }>Cancelar</button>
					<button className="btn btn-default" type="button" onClick={ modalDelete.get('action') }>Ok</button>
				</ModalFooter>
			</Modal>
		)
	}
}

const mapStateToProps = (state, onwProps) => {
	return {
		modalDelete: state.garantias.get('modalDelete')
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		showHideModalDelete: (open) => dispatch(showHideModalDelete(open))
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalDelete)



// WEBPACK FOOTER //
// ./src/components/Garantias/ModalDelete.jsx